export default __webpack_public_path__ + "static/media/IsaiahBio.6b43df66.jpg";